import { render, staticRenderFns } from "./WaybillGroupDetailView.vue?vue&type=template&id=29794db2&"
import script from "./WaybillGroupDetailView.vue?vue&type=script&lang=js&"
export * from "./WaybillGroupDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports